(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    if (!window.__reviewStarsScrollInit) {
    window.__reviewStarsScrollInit = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-scroll-to-reviews]');
      if (!trigger) return;

      const target = document.getElementById('judgeme_product_reviews');
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      if (history && history.replaceState) {
        history.replaceState(null, '', '#judgeme_product_reviews');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
